import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { TransferSuccessIcon } from "../../icon";
import * as selector from '../../selectors/selectors';
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import { appNote, buttonLabels, ViewTextLabels } from "../shared/constants";

interface Props {
    HandleNext: (x) => void;
    Stepdata: any
}

const TransferStatusComponent = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    useEffect(() => {
        setTimeout(() => {
            sessionStorage.removeItem("transfers")
        }, 10);
    }, [])

    return (
        <div className={IsMobileDevice ? "w-fill p-1 bg-color-secondary my-auto" : `d-flex w-p-80 m-auto b-none br-3 bg-color-secondary`}>

            <div className={`m-auto ${IsMobileDevice ? 'w-p-100' : 'w-p-90 settings-paper-border px-8 py-auto br-3 p-5'} t-align-center printme`}>
                <div id="print">
                    <div className={`pt-2`}> <TransferSuccessIcon /> </div>
                    <div className={`h1-semibold color-primary-success pb-1 pt-1`} >{appNote.TRANSFER_COMPLETED} </div>

                    <div className="bb-primary-background-pink-4 mt-2"></div>

                    <Grid container className={"mt-3"} direction="row" spacing={3}>

                        <Grid item className="d-flex" xs={IsMobileDevice ? 12 : 6} md={6}>
                            <Grid item xs={4} className={`h5-semibold color-primary-accent w-space t-align-left py-1`}>
                                {ViewTextLabels.FROM}
                            </Grid>
                            <Grid item xs={8} className={`h6-regular t-align-left payment-status-word py-1`} id="print-font" >
                                {
                                    (props?.Stepdata.SourcePhoneNumber || props.Stepdata.SourcePhoneNumber) && (props?.Stepdata.SourcePhoneNumberName || props.Stepdata.SourcePhoneNumberName) ?
                                        `${UtilityService.maskPhoneNumberOnLength(props?.Stepdata.SourcePhoneNumber || props.Stepdata.SourcePhoneNumber)} - ${props?.Stepdata.SourcePhoneNumberName || props.Stepdata.SourcePhoneNumberName}`
                                        : "--"
                                }

                            </Grid>
                        </Grid>
                        <Grid item className="d-flex" xs={IsMobileDevice ? 12 : 6} md={6}>
                            <Grid item xs={4} className={`h5-semibold color-primary-accent t-align-left py-1`} >
                                {ViewTextLabels.CREDIT_TYPE}
                            </Grid>
                            <Grid item xs={8} className={`h6-regular t-align-left py-1`} id="print-font">
                                {props?.Stepdata.CreditTypeText || props.Stepdata.CreditTypeText || "--"}
                            </Grid>
                        </Grid>
                        <Grid item className="d-flex" xs={IsMobileDevice ? 12 : 6} md={6}>

                            <Grid item xs={4} className={`h5-semibold color-primary-accent t-align-left py-1`} >
                                {ViewTextLabels.TO}
                            </Grid>
                            <Grid item xs={8} className={`h6-regular t-align-left py-1`} id="print-font">
                                {
                                    (props.Stepdata?.TargetPhoneNumber || props.Stepdata.TargetPhoneNumber) && (props.Stepdata?.TargetPhoneNumberName || props.Stepdata.TargetPhoneNumberName) ?
                                        `${UtilityService.maskPhoneNumberOnLength(props?.Stepdata.TargetPhoneNumber || props.Stepdata.TargetPhoneNumber)} - ${props?.Stepdata.TargetPhoneNumberName || props.Stepdata.TargetPhoneNumberName}`
                                        : "--"
                                }
                            </Grid>
                        </Grid>
                        <Grid item className="d-flex" xs={IsMobileDevice ? 12 : 6} md={6}>

                            <Grid item xs={4} className={`h5-semibold color-primary-accent t-align-left py-1`}>
                                {ViewTextLabels.CREDIT_AMOUNT}
                            </Grid>
                            <Grid item xs={8} className={`h6-regular w-space t-align-left py-1`} id="print-font">
                                {props?.Stepdata.CreditsToTransfer || props.Stepdata.CreditsToTransfer || "--"}
                            </Grid>
                        </Grid>
                    </Grid>

                </div>

                <div className={`${IsMobileDevice ? 'mx-auto' : 'd-flex t-align-center justify-center'} my-3 no-printme`}>
                    <Link to={AppRoutes.TRANSFER_LOGS} className="primary-btn">{buttonLabels.GO_TO_LOGS}</Link>
                </div >
            </div>
        </div >
    )
}


export default TransferStatusComponent;